export default __webpack_public_path__ + "static/media/fox-logo.952a805d.svg";